import store from '@/store'
import router from '@/router'
import { ref, getCurrentInstance } from '@vue/composition-api'
import { foundryRequest } from '@/config/authConfig';
import { stringToHslColor, dateInPast } from '@core/utils'
import { diffInDays } from '@core/utils/filter'

export default function useProjectView() {

  const vm = getCurrentInstance().proxy
  const projectData = ref({})
  const updateLoading = ref(false)
  const csatSurvey = ref({})
  const csatResult = ref([])
  const packDescProjects = ref([])
  const normsLoading = ref(false)
  const mappingsData = ref([])
  const mappingsLoading = ref(false)
  const totalMappings = ref(0)
  
  const datamapSearch = ref('')
  const options = ref({ page: 1, itemsPerPage: 10, sortBy: ['updated_at'], sortDesc: [true] })


  // fetch data
  const fetchProject = async () => {
    
    
    store
      .dispatch('app-project/fetchProject', {
        id:router.currentRoute.params.id
      })
      .then(response => {
        const { data } = response

        projectData.value = updateData(data)

      })
      .catch(error => {
        console.log(error)
        router.push({
          name: 'misc-error'
        })
      })
  }

  const updateProject = async (data) => {
    updateLoading.value = true
    
    store
      .dispatch('app-project/updateProject', {
        id:router.currentRoute.params.id || data.job_number,
        data: data
      })
      .then(response => {
        const { data } = response
        updateLoading.value = false
        projectData.value = updateData(data)
        // params.loading.value = false

        store.commit('comp-alert/SET_MESSAGE', {})
        
      })
      .catch(error => {
        console.log(error)
        updateLoading.value = false
        store.commit('comp-alert/SET_MESSAGE', error.response.data)
        // router.push({
        //   name: 'misc-error'
        // })
      })
      updateLoading.value = false
  }

  const fetchCSATSurvey = async () => {
    
    store
      .dispatch('app-project/fetchCSATSurvey', {
        id:`csat.${router.currentRoute.params.id.toLowerCase()}`
      })
      .then(response => {
        const { data } = response
        csatSurvey.value = data
        
      })
      .catch(error => {
        console.log(error)
        // updateLoading.value = false
        // router.push({
        //   name: 'misc-error'
        // })
      })
  }

  const fetchCSATResult = async () => {
    
    store
      .dispatch('app-project/fetchCSATResult', {
        id:`csat.${router.currentRoute.params.id.toLowerCase()}`
      })
      .then(response => {
        const { data } = response
        csatResult.value = data
      })
      .catch(error => {
        console.log(error)
        // updateLoading.value = false
        // router.push({
        //   name: 'misc-error'
        // })
      })
  }
  
  const addCSATResult = async (csatResult) => {
    
    const csatResultLocal = JSON.parse(JSON.stringify(csatResult))
    store
      .dispatch('app-project/addCSATResult', csatResultLocal)
      .then(response => {
        const { data } = response
        csatResult.value = [data]
        fetchCSATResult()
      })
      .catch(error => {
        console.log(error)
      })
  }

  
  const addMarket = async (data) => {
    
    store
      .dispatch('app-project/addMarket', {id: router.currentRoute.params.id.toLowerCase(), data})
      .then(response => {
        const { data } = response
        fetchProject()
        
      })
      .catch(error => {
        console.log(error)
      })
  }

    const fetchPackDescProjects = async (data) => {
        normsLoading.value = true
        await store
            .dispatch('app-project/fetchPackDescProjects', data.job_number
            )
            .then(response => {
            const { data } = response
            packDescProjects.value = data

             
            // remove loading state
            normsLoading.value = false
            
            })
            .catch(error => {
                console.log(error)
                normsLoading.value = false
            
            })
    }

    const addPackDescProject = async (payload) => {
        updateLoading.value = true
        
        await store
            .dispatch('app-project/addPackDescProject', payload)
            .then(response => {
            const { data } = response
            fetchProject()
             
            // remove loading state
            updateLoading.value = false
            
            })
            .catch(error => {
                console.log(error)
                updateLoading.value = false
            
            })
    }



  const updateData = (data) => {

    const daysInField = diffInDays(data.field_start, data.field_end, true)
    const fieldStartInDate = dateInPast(new Date(data.field_start), new Date())
    const daysStarted = fieldStartInDate ? Math.min(diffInDays('today', data.field_start, true), daysInField) : 0
    return {
      ...data,
      color: stringToHslColor(data.job_name),
      days_in_field: daysInField,
      days_started: daysStarted,
      days_remaining: daysInField-daysStarted <= 0 ? 0: daysInField-daysStarted,
      field_progress: daysStarted / daysInField * 100
    }

  }

  const resolveCountryStatusVariant = status => {
    if (status === 'PRE') return 'primary'
    if (status === 'IN') return 'info'
    if (status === 'POST') return 'accent'
    if (status === 'COMP') return 'success'
    if (status === 'HOLD') return 'warning'
    if (status === 'CLD') return 'error'

    return 'primary'
  }
  
  const resolveCountryStatusLabelVariant = status => {
    if (status === 'PRE') return 'Pre-Field'
    if (status === 'IN') return 'In-Field'
    if (status === 'POST') return 'Post-Field'
    if (status === 'COMP') return 'Completed'
    if (status === 'HOLD') return 'On-Hold'
    if (status === 'CLD') return 'Cancelled'

    return 'No Status'
  }

  const fetchDatamap = async (params) => {
        
        return store
          .dispatch('app-project/fetchDatamap', {
            ...params
          })
          .then(response => {
            const { data } = response
            return data
          })
          .catch(error => {
            console.log(error)
          })
      }
  


  const fetchMappings = () => {
    mappingsLoading.value = true
    const queryParams = {
      page: options.value.page,
      search: datamapSearch.value,
    }

    store.dispatch('app-project/fetchMappings', queryParams)
      .then(response => {
        mappingsData.value = response.data.results || response.data
        totalMappings.value = response.data.count || response.data.length
      })
      .catch(error => console.error(error))
      .finally(() => { mappingsLoading.value = false })
  }

  // --- 2. Create a brand new Mapping from the UI Modal ---
  const createMapping = async (payload) => {
    return store.dispatch('app-project/createMapping', payload)
  }
  const fetchDatamapMapping = async (countryId) => { // Accept raw ID instead of object
  return store.dispatch('app-project/fetchDatamapMapping', countryId)
    .then(response => response.data)
    .catch(err => {
        if(err.response && err.response.status === 404) return null; 
        console.error(err)
        throw err
    })
}

const saveDatamapMapping = async (payload) => {
  return store.dispatch('app-project/saveDatamapMapping', payload)
    .then(response => response.data)
    .catch(err => {
        console.error(err)
        throw err
    })
  }
  

  return {
    projectData,
    updateLoading,
    csatSurvey,
    csatResult,
    normsLoading,
    packDescProjects,mappingsData,
    mappingsLoading,
    totalMappings,
    datamapSearch,
    options,
    

    fetchPackDescProjects,
    addMarket,
    fetchProject,
    updateProject,
    fetchCSATSurvey,
    fetchCSATResult,
    addCSATResult,
    resolveCountryStatusVariant,
    resolveCountryStatusLabelVariant,
    addPackDescProject,
    fetchDatamap,
    fetchMappings,
    createMapping,
    fetchDatamapMapping,
    saveDatamapMapping
  }
}
